import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public screenSize = new BehaviorSubject<string>('SM');//SM, MD,LG,XL
  constructor(private breakptObserver: BreakpointObserver) { 
    this.breakptObserver.observe(['(min-width: 1024px)', '(min-width: 1280px)', '(min-width: 1440px)','(min-width: 1920px)']).subscribe( result => {
      if(result.breakpoints['(min-width: 1920px)']){
        this.screenSize.next('XL');
      } else if(result.breakpoints['(min-width: 1440px)']){
        this.screenSize.next('LG');
      } else if(result.breakpoints['(min-width: 1280px)']){
        this.screenSize.next('MD');
      } else if(result.breakpoints['(min-width: 1024px)']){
        this.screenSize.next('SM');
      }
    });
  }

}
